import React, { Component } from 'react'
import Row from '../../components/Row'

export default class Paginate extends Component {
  render() {
    const { children } = this.props

    return (
      <Row style={{ marginTop: '3rem' }}>
        {children}
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Paginate/Paginate.js